import { createSelector, createFeatureSelector } from '@ngrx/store';
import { accountFeatureKey, AccountState } from './account.reducer';

export const accountFeatureSelector = createFeatureSelector<AccountState>(accountFeatureKey);

export const getUser = createSelector(
  accountFeatureSelector,
  (state: AccountState) => state.user
);
